<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
  <img src="assets/img/loding.gif" />
</div>
<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/camp.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="pagename">
                    <h3 class="card-title">Testimonials</h3>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>{{ testimonialsTotal ? testimonialsTotal : 0 }}</h2>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="addbtn">
                    <button
                      id="add_btn"
                      type="button"
                      class="btn btn-primary addbtn"
                      (click)="open(content)"
                      style="float: right"
                    >
                      Add Testimonials
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <!-- <p><button type="button" *ngIf="pdf" class="btn btn-secondary btn-sm" title="PDF" (click)="pdfExport()"><i class="fa fa-file-pdf-o"></i> PDF</button> <button type="button" *ngIf="exl" title="XL" class="btn btn-secondary btn-sm" (click)="xlExport()"><i class="fa fa-file-excel-o"></i> Excel</button></p> -->
            <div id="table" class="table-responsive">
              <table
                datatable
                id="testimonialTable"
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table"
                width="100%"
              >
                <thead>
                  <tr>
                    <th style="width: 5%">#Sl</th>
                    <th>Name</th>
                    <th>Designation</th>
                    <th>Company Name</th>
                    <th>Created Date</th>
                    <th style="width: 5%">Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody *ngIf="testimonialsList?.length != 0">
                  <tr
                    *ngFor="let item of testimonialsList; let i = index"
                    [attr.data-index]="i"
                  >
                    <td>{{ getRowNumber(i) }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.designation }}</td>
                    <td>{{ item.company_name }}</td>
                    <td>{{ item.created_at }}</td>
                    <td>
                      <span
                        *ngIf="item.status == 'Y'"
                        class="badge badge-success badge-pill"
                        >Active</span
                      >
                      <span
                        *ngIf="item.status == 'N'"
                        class="badge badge-danger badge-pill"
                        >Inactive</span
                      >
                    </td>

                    <td class="action">
                      <label class="switch">
                        <input
                          type="checkbox"
                          (change)="statusChange(item)"
                          [checked]="item.status === 'Y'"
                        />
                        <span class="slider round"></span>
                      </label>

                      <button
                        type="button"
                        class="btn text-dark btn-sm rounded bg-light"
                        (click)="edit(this.testimonialsList[i].id, content)"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                      <button
                        class="ml-1 btn text-danger btn-sm rounded bg-light"
                        (click)="delete(item)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="testimonialsList?.length == 0">
                  <tr>
                    <td colspan="8" class="no-data-available text-center">
                      No data available!
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template
      #content
      let-c="close"
      let-d="dismiss"
      id="customer-add"
      class=""
    >
      <!-- class="modal fade" -->
      <div class="modal-info" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ modalTitle }}</h4>
            <button
              type="button"
              class="close"
              aria-label="Close"
              (click)="d('Cross click')"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <alert>
              <div class="alert alert-danger"><a class="close">×</a></div>
            </alert>

            <form
              method="post"
              enctype="multipart/form-data"
              class="form-horizontal"
              #f="ngForm"
            >
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="name" class="col-form-label"
                    >Name <span>*</span></label
                  >
                  <div class=" ">
                    <input
                      class="form-control"
                      type="text"
                      id="name"
                      name="name"
                      required
                      [(ngModel)]="testimonials.name"
                    />
                    <span
                      *ngIf="isSubmitted && isFieldsInvalid(testimonials.name)"
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="designation" class="col-form-label"
                    >Designation <span>*</span></label
                  >
                  <div class=" ">
                    <input
                      class="form-control"
                      type="text"
                      id="designation"
                      name="designation"
                      required
                      [(ngModel)]="testimonials.designation"
                    />
                    <span
                      *ngIf="
                        isSubmitted && isFieldsInvalid(testimonials.designation)
                      "
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="company_name" class="col-form-label"
                    >Company Name <span>*</span></label
                  >
                  <div class=" ">
                    <input
                      class="form-control"
                      type="text"
                      id="company_name"
                      name="company_name"
                      required
                      [(ngModel)]="testimonials.company_name"
                    />
                    <span
                      *ngIf="
                        isSubmitted &&
                        isFieldsInvalid(testimonials.company_name)
                      "
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="message" class="col-form-label"
                    >Message
                    <span style="color: black; font-size: smaller"
                      >(You cannot exceed 200 characters)</span
                    >
                    <span>*</span>
                  </label>
                  <div class="">
                    <textarea
                      class="form-control"
                      maxlength="200"
                      type="text"
                      required
                      id="message"
                      name="message"
                      [(ngModel)]="testimonials.message"
                    ></textarea>

                    <span
                      *ngIf="
                        isSubmitted && isFieldsInvalid(testimonials.message)
                      "
                      class="alert-block text-sm"
                      >This field is required</span
                    >
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="status" class="col-form-label"
                    >Status <span>*</span></label
                  >
                  <div class=" ">
                    <select
                      class="form-control"
                      id="status"
                      name="status"
                      [(ngModel)]="testimonials.status"
                    >
                      <option value="N">Inactive</option>
                      <option value="Y">Active</option>
                    </select>
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label class="form-control-label">Image <span>*</span></label>
                  <div class="">
                    <img
                      style="height: 100px; width: 100px; padding: 0"
                      class="img-thumbnail mb-3"
                      *ngIf="croppedImage != ''"
                      [src]="croppedImage"
                    />
                    <div class="input-group">
                      <span class="input-group-btn">
                        <label class="btn btn-dark">
                          <samp>Browse</samp>...
                          <input
                            type="file"
                            accept="{{ fileType }}"
                            style="display: none"
                            (change)="onFileChange($event)"
                            [required]="!isEditMode"
                            [attr.multiple]="allowMultiple"
                          />
                        </label>
                      </span>
                      <input
                        type="text"
                        class="form-control"
                        [value]="DisplayedText"
                        disabled=""
                        [class.ng-invalid-right]="required && !DisplayedText"
                        [class.ng-valid-right]="required && DisplayedText"
                        style="height: 35px"
                      />
                    </div>

                    <span
                      *ngIf="
                        isSubmitted && !imageError && !isEditMode && !fileList
                      "
                      class="alert-block"
                    >
                      This field is required
                    </span>

                    <span *ngIf="imageError" class="alert-block">
                      {{ imageError }}
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary d-none"
              aria-label="Close"
              (click)="d('Cross click')"
            >
              Close
            </button>
            <button
              type="submit"
              class="btn btn-primary savebtn"
              (click)="save(this.testimonials, f)"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
